module.exports = __webpack_public_path__ + "static/media/lp3.52a08f5e.jpg";